import { SvgProps } from "../../types";

export default function ChevronDownIcon({ stroke, className }: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke={stroke || "#0b132b"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <polyline points="6 9 12 15 18 9" />
        </svg>
    );
}
